import store from "@store/index";
import { useCreation } from "ahooks";
import { Button, Modal } from "antd";
import { getIt } from "@uikit/getIt";
import func from "@uikit/func";
import { useDispatch } from "react-redux";
import styles from "./Unpublish.module.scss";
import { studioActions } from "@store/studio";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { UnpublishBloc, UnpublishBlocState } from "./UnpublishBloc";
import useFeatureTags from "../../../../../custom-hooks/useFeatureTags";
import { BrainClient } from "imagica-corekit/dist/base/api/BrainClient";
import useObjectRelationGqlRequest from "@custom-hooks/useObjectRelationGqlRequest";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot/container";
import { useHomeChildContainer } from "@custom-hooks/HomeUsePluginRoot/childContainer";
import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
import { CheckedUIListType } from "@custom-hooks/HomeUsePluginRoot/state/useSaasAndThinkAppState";
import { WEB_APP_DEFAULT_SUBTITLE, WEB_APP_DEFAULT_TITLE } from "@views/thinking-layout-editor/constants";
import { PowerMaskView } from "@uiview/views/PowerMask/PowerMaskView";
import { logEvent } from "@uikit/service/amplitude";

const CLOSE_ICON = "https://dopniceu5am9m.cloudfront.net/static/assets/230705/ACAEB5Cross.svg";
const TITLE = "Are you sure you want to Unpublish?";
// const SUBTITLE = "This will delete this publish format from your project. You can not undo this action.";
const SUBTITLE =
  "This app is being unpublished by its creator. You will still have access until the end of your monthly subscription period.";
export function Unpublish() {
  const dispatch = useDispatch();

  const state = new UnpublishBlocState();
  const bloc = useCreation(() => new UnpublishBloc(state), []);

  const brainClient = getIt(BrainClient);

  const setSelectedTemplate = (val: any) => {
    dispatch(studioActions.setSelectedTemplate(val));
  };
  const { gql } = useObjectRelationGqlRequest();
  const { getUIListParam } = useHomeChildContainer();
  const { isNewEdgeRunRef } = useHomeUsePluginContainer();
  const { disableSelectTemplate } = useFeatureTags();
  const { getPublishMetadata, clearPublishMetadata, getSelectedTemplate, previewAppActiveIdSignal } =
    usePreviewAppStore();

  const published_metadata = getPublishMetadata();
  const disabledUnPublish = func.isEmpty(published_metadata?.link);

  function handleOk() {
    handleUnpublishV2();
  }

  async function handleUnpublishV2() {
    try {
      bloc.state.unpublishLoading.value = true;
      const selectedTemplate = getSelectedTemplate();
      if (selectedTemplate === undefined) {
        throw Error("can not find app");
      }
      if (!func.isEmpty(published_metadata?.published_at)) {
        const linkMateData = selectedTemplate.published_metadata_v2?.find(item => {
          return item.id === previewAppActiveIdSignal.value;
        });
        if (linkMateData?.link) {
          const linkUrl = new URL(linkMateData?.link.replace("#/", ""));
          const query = linkUrl.searchParams.get("q") ?? "";
          await brainClient.user.unpublish(query);
          const setingUIData = selectedTemplate.v3?.UI?.find((item: any) => {
            return item.id === linkMateData.id;
          });
          logEvent("unpublish", {
            URL: linkMateData?.link,
            publish_view_name: setingUIData?.title,
            name: setingUIData?.v2App?.appName,
            uuid: linkMateData.uuid,
          });
        }
      }
      const newTemplate = clearPublishMetadata();
      await gql.mutation.updateObject(parseInt(selectedTemplate.id), {
        name: "studio_project",
        attributes: newTemplate,
      });
      setSelectedTemplate(newTemplate);
      bloc.state.showModal.value = false;

      backPublishPage();
    } catch (error) {
      func.messageError(error);
    } finally {
      bloc.state.unpublishLoading.value = false;
    }
  }

  const handleUnpublishV15 = async () => {
    try {
      bloc.state.unpublishLoading.value = true;
      const selectedTemplate: any = store.getState().studio.selectedTemplate;

      let updatedProject = {};
      let uiObj: any[] = [];
      if (disableSelectTemplate) {
        const arr = [
          {
            label: "AI App",
            value: "saas",
            isStaticApp: false,
          } as CheckedUIListType,
        ];

        uiObj = getUIListParam(arr);
        uiObj.forEach(item => {
          item.title = WEB_APP_DEFAULT_TITLE;
          item.subTitle = WEB_APP_DEFAULT_SUBTITLE;
          item.input = [];
          item.output = [];
          item.staticMode = false;
        });
      }

      if (isNewEdgeRunRef.current) {
        updatedProject = {
          ...selectedTemplate,
          v3: { ...selectedTemplate.v3, UI: uiObj },
        };
      } else {
        updatedProject = { ...selectedTemplate, v2: { ...selectedTemplate.v2, UI: uiObj } };
      }

      // sutd-1722: published_metadata
      if (!func.isEmpty(published_metadata?.published_at)) {
        // if (!util.isEmpty(selectedTemplate.published_metadata?.published_at)) {
        await brainClient.user.unpublish(selectedTemplate.index);
      }

      // stud-1722: unpublish 应该去掉 global metadata 和 appid 对应的 publish metadata
      // const newTemplate = clearPublishMetadata();
      const newTemplate = Object.assign({}, updatedProject, { published_metadata: {} });
      await gql.mutation.updateObject(parseInt(selectedTemplate.id), {
        name: "studio_project",
        attributes: newTemplate,
      });
      setSelectedTemplate(newTemplate);

      bloc.state.showModal.value = false;

      backPublishPage();
    } catch (error) {
      func.messageError(error);
    } finally {
      bloc.state.unpublishLoading.value = false;
    }
  };

  function backPublishPage() {
    // 以前的代码 完成后是返回到上一页，新的 ui 流程不确定。
  }

  if (disabledUnPublish) return <div></div>;

  return (
    <PowerMaskView feature={[]}>
      <div className={styles.unpublishBox}>
        <div className={styles.title}>Unpublish</div>
        <div className={styles.subTitle}>Hide this publish view from the public.</div>
        <div
          className={styles.buttonBox}
          onClick={() => {
            const selectedTemplate = getSelectedTemplate();
            bloc.showUnpublishModal(disabledUnPublish, previewAppActiveIdSignal.value as string, selectedTemplate);
          }}
        >
          Unpublish
        </div>

        {bloc.state.showModal.value && (
          <div className={styles.modalRoot}>
            <Modal
              open={bloc.state.showModal.value}
              wrapClassName={styles.modalWrap}
              width="400px"
              centered={true}
              closeIcon={<img src={CLOSE_ICON} width="20" height="20" alt="close" />}
              footer={null}
              onOk={handleOk}
              onCancel={() => bloc.handleCancel()}
            >
              <ExclamationCircleOutlined className={styles.modalIcon} />
              <span className={styles.modalTitle}>{TITLE}</span>
              {bloc.state.showSubTitle.value && <p className={styles.modalSubtitle}>{SUBTITLE}</p>}
              <div className={styles.modalFooter}>
                <Button
                  data-testid="Preview-Settings-Unpublish-Cancel"
                  shape="round"
                  size="large"
                  type="default"
                  className={styles.modalButtonNormal}
                  onClick={() => bloc.handleCancel()}
                >
                  Cancel
                </Button>
                <Button
                  data-testid="Preview-Settings-Unpublish-Confirm"
                  shape="round"
                  size="large"
                  className={styles.modalButtonDanger}
                  loading={bloc.state.unpublishLoading.value}
                  onClick={handleOk}
                >
                  Unpublish
                </Button>
              </div>
            </Modal>
          </div>
        )}
      </div>
    </PowerMaskView>
  );
}
